import { render, staticRenderFns } from "./SubmissionOfferForm.vue?vue&type=template&id=b7d165f8&scoped=true&"
import script from "./SubmissionOfferForm.vue?vue&type=script&lang=js&"
export * from "./SubmissionOfferForm.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionOfferForm.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SubmissionOfferForm.vue?vue&type=style&index=1&id=b7d165f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7d165f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCardText,VDialog,VForm,VIcon,VTooltip})
